import React from 'react';
import { useSelector } from 'react-redux';
import BtnComponent from '../../../../ui/buttons/BtnComponent';
import ItemBlock from '../../itemBlock/ItemBlock';
import classes from './GamificationMonstersBlock.module.css';

const GamificationMonstersBlock = ({ title, text, leftImage, rightImage, button }) => {

    const { texts } = useSelector(state => state.translate);

    return (
        <ItemBlock title={title ? (texts[title] || title) : null}>
            <div className={classes.content}>
                <div className={classes.leftSection}>
                    {rightImage && (
                        <div className={classes.rightImageContainer}>
                            <img src={rightImage.src} alt={rightImage.alt || ''} className={classes.rightImage} />
                        </div>
                    )}
                </div>
                <div className={classes.centerSection}>
                    {text && <p className={classes.text}>{texts[text] || text}</p>}
                    {button &&
                        <div className={classes.buttonContainer}>
                            <BtnComponent className={classes.button} type={button.type} text={texts[button.text] || button.text} />
                        </div>}
                </div>
                <div className={classes.rightSection}>
                    {leftImage && (
                        <div className={classes.leftImageContainer}>
                            <img src={leftImage.src} alt={leftImage.alt || ''} className={classes.leftImage} />
                        </div>
                    )}
                </div>
            </div>
        </ItemBlock>
    );
};

export default GamificationMonstersBlock;

